import { GenericHandlerConfig, GenericVideoHandler } from './Generic';

export type HivestackHandlerConfig = GenericHandlerConfig & {
    videoUrl: string;
};

/**
 * A handler to play video advertisements from Hivestack
 */
export class HivestackVideoHandler extends GenericVideoHandler {
    protected _type: string;
    protected _videoId: string;
    constructor(config: HivestackHandlerConfig) {
        super(config);
        this._videoId = config.videoUrl;
        this._videoUrl = config.videoUrl;
        this._type = 'hivestack';
    }
}
